import { render, staticRenderFns } from "./ThgIsCompanyRequired.vue?vue&type=template&id=2523146e"
import script from "./ThgIsCompanyRequired.vue?vue&type=script&lang=ts"
export * from "./ThgIsCompanyRequired.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports